export const elementsQuestions = [
  { name: 'The Elements', key: 'elements' },
  { name: 'Assets', key: 'assets' },
  { name: 'Liabilities', key: 'liabilities' },
  { name: 'Equity', key: 'equity' },
  { name: 'Revenues', key: 'revenues' },
  { name: 'Expenses', key: 'expenses' },
  { name: 'Accruals & Deferrals', key: 'accruals_deferrals' },
  { name: 'Contra-Accounts', key: 'contra_accounts' }
];

export const popupMessagesDecisionInsightsOverall = [
  {
    name: 'Bailey',
    text: '{allGamesUsersCount} out of {courseMembersCount} students in your class have completed at least one assignment. Here’s their overall accuracy score, grouped by exercise type.<br>',
    alignment: 'top'
  }
];

export const popupMessagesDecisionInsightsNoGamesData = [
  {
    name: 'Bailey',
    text: 'Hang tight! Data will appear as soon as a student completes an assignment.<br>',
    alignment: 'top'
  }
];

export const popupMessagesDecisionInsightsClassifyingNormal = [
  {
    name: 'Bailey',
    text: 'Here’s a snapshot of your class understanding of how accounts they’ll encounter should be classified and what their normal balances are. We’ve broken it down by the 5 Elements, specific accounts within each Element, and accounts that often cause confusion, like accruals, deferrals, and contra-accounts.',
    alignment: 'top'
  }
];

export const popupMessagesDecisionInsightsDoubleEntry = [
  {
    name: 'Bailey',
    text: 'Here’s a snapshot of how well your class applied their understanding of double-entry accounting. <br><br>In the exercise, they reviewed a series of transactions and started with how each affected the accounting equation, then zoomed in on debits and credits, and finally specific accounts.',
    alignment: 'top'
  }
];

export const popupMessagesDecisionInsightsPrinciples = [
  {
    name: 'Bailey',
    text: 'Here’s a snapshot of how well your class applied their understanding of Assumptions, Principles, and Constraints concepts.',
    alignment: 'top'
  }
];

export const classifyingNormalSections = [
  {
    bars: [{ title: 'The Elements', key: 'elements' }],
  },
  {
    title: 'Various Accounts Under The Elements',
    bars: [
      { title: 'Assets', key: 'assets' },
      { title: 'Liabilities', key: 'liabilities' },
      { title: 'Equity', key: 'equity' },
      { title: 'Revenues', key: 'revenues' },
      { title: 'Expenses', key: 'expenses' },
    ]
  },
  {
    title: 'Tricky Accounts',
    bars: [
      { title: 'Accruals & Deferrals', key: 'accruals_deferrals' },
      { title: 'Contra-Accounts', key: 'contra_accounts' }
    ]
  }
];

export const classifyingNormalElementsHeaders = ['Balance Sheet', 'Income Statement'];
export const classifyingNormalAllOtherAccountsHeaders = ['Assets', 'Liabilities', 'Equity', 'Revenues', 'Expenses'];
export const classifyingNormalElementsOtherAccountsNormalHeaders = ['Debit', 'Credit'];

export const summaryDecisionBreakdownElementsToDiplay = [
  'Increase', 'Decrease', 'Debit', 'Credit'
];

export const decisionBreakdownElementsHeadersDoubleEntry = [
  'Assets', 'Liabilities', 'Equity'
];

export const decisionBreakdownElementsHeadersPrinciples = [
  'Impact on Profits'
];

export const chartAttemptLabels = {
  1: 'Initial Attempt',
  2: 'Second',
  3: 'Final'
};

export const chartLines = [
  { dataKey: 'classification', name: 'Classification', color: '#B4E6EA', countKey: 'classificationCount' },
  { dataKey: 'normalBalance', name: 'Normal Balance', color: '#FCE0B0', countKey: 'normalBalanceCount' },
  { dataKey: 'principles', name: 'Principles', color: '#91B6FD', countKey: 'principlesCount' },
  { dataKey: 'balancedEquation', name: 'Balanced Equation', color: '#A98DF6', countKey: 'balancedEquationCount' },
];